import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { useGetRewards } from '@ping/api';
import { t } from '@ping/helpers';
import { useIsUserLoggedIn } from '@ping/hooks';
import {
  isUserActivityStatusActiveSelector,
  isUserComplianceReviewerSelector,
  isUserSupportSelector,
  isUserTradeDataViewerSelector,
  useUserInformationStore,
} from '@ping/stores/userInformation.store';
import { useBusinessKybLock } from '@ping/pages/business/verification/use-business-kyb-lock';
import { hasUnclaimedRewards } from '@ping/utils/reward.util';

import Banner from '../Banner';

import style from './style.module.scss';

const RewardsAvailableBanner = () => {
  const router = useRouter();
  const isUserLoggedIn = useIsUserLoggedIn();
  const isUserActivityStatusActive = useUserInformationStore(isUserActivityStatusActiveSelector);
  const isUserComplianceOfficer = useUserInformationStore(isUserComplianceReviewerSelector);
  const isUserTradeDataViewer = useUserInformationStore(isUserTradeDataViewerSelector);
  const isUserSupport = useUserInformationStore(isUserSupportSelector);
  const lockedToKyb = useBusinessKybLock();

  const { data: rewardsData } = useGetRewards(
    { page: 1, perPage: 20 },
    {
      query: {
        enabled:
          isUserLoggedIn &&
          isUserActivityStatusActive &&
          !isUserComplianceOfficer &&
          !isUserTradeDataViewer &&
          !isUserSupport &&
          !lockedToKyb,
      },
    }
  );

  const showBanner = useMemo(
    () => isUserActivityStatusActive && hasUnclaimedRewards(rewardsData),
    [isUserActivityStatusActive, rewardsData]
  );

  return (
    <Banner
      show={showBanner}
      headerTag='h4'
      message={t('You have a reward available')}
      extraMessage={t('View rewards')}
      messageClassName={style['banner__message']}
      showIcon={false}
      bannerType='success'
      onClick={() => void router.push('/user/rewards')}
    />
  );
};

export default RewardsAvailableBanner;
